import join from 'url-join';

import { asyncAction, createAction, http } from '../util/index';
import { showToast } from '../components/toast/actions';
import { TranslatedCopy } from '../intl/TranslatedCopy';

const api = join(import.meta.env.VITE_API_URL, 'v1');

export const saveCurrentAllotments = asyncAction({
  baseName: 'SAVE_CURRENT_ALLOTMENTS',
  action: action => ({ accountNumber }, values) => dispatch => {
    dispatch(action.start(values, accountNumber));

    return http
      .put(join(api, `/account/${accountNumber}/allotments/current`), values)
      .then(({ data: response }) => {
        dispatch(
          showToast({
            message: new TranslatedCopy({ id: 'allotments.toast.success.departments' }).toString(),
            type: 'success'
          })
        );
        return dispatch(action.success(response));
      })
      .catch(error => {
        dispatch(
          showToast({
            type: 'error',
            message: new TranslatedCopy({ id: 'global.toast.systemError' }).toString(),
            error
          })
        );
        return dispatch(action.error({ error }));
      });
  }
});

export const saveFutureAllotments = asyncAction({
  baseName: 'SAVE_FUTURE_ALLOTMENTS',
  action: action => ({ accountNumber }, values) => dispatch => {
    dispatch(action.start(values, accountNumber));

    return http
      .put(join(api, `/account/${accountNumber}/allotments/future`), values)
      .then(({ data: response }) => {
        dispatch(
          showToast({
            message: new TranslatedCopy({ id: 'allotments.toast.success.departments' }).toString(),
            type: 'success'
          })
        );
        return dispatch(action.success(response));
      })
      .catch(error => {
        dispatch(
          showToast({
            type: 'error',
            message: new TranslatedCopy({ id: 'global.toast.systemError' }).toString(),
            error
          })
        );
        return dispatch(action.error({ error }));
      });
  }
});

export const requestCurrentCartCrd = asyncAction({
  baseName: 'REQUEST_CURRENT_CART_CRD',
  action: action => ({ accountNumber }) => dispatch => {
    dispatch(action.start(accountNumber));

    return http
      .get(join(api, `/cart/futures/crd/account/${accountNumber}`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const requestForecastDepartments = asyncAction({
  baseName: 'REQUEST_FORECAST_DEPARTMENTS',
  action: action => ({ accountNumber }) => dispatch => {
    dispatch(action.start(accountNumber));

    return http
      .get(join(api, `/cart/forecast/departments/account/${accountNumber}`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const setUseCurrentContract = createAction('SET_USE_CURRENT_CONTRACT');
export const updateAllotment = createAction('UPDATE_ALLOTMENT');
